/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { pageTypes } from '@/utils/analytics/legacyUtils/pageTypes';

/**
 * Determines if the given pageType represents a Product Detail Page (PDP)
 * Used to conditionally include PDP-specific analytics variables
 */
export const isPdpPage = (pageType: string | undefined): boolean => {
  return pageType === pageTypes.pdp || pageType === pageTypes.productDetails;
};
